import { render, staticRenderFns } from "./help-navigation.component.vue?vue&type=template&id=239fd694&scoped=true&"
import script from "./help-navigation.component.ts?vue&type=script&lang=ts&"
export * from "./help-navigation.component.ts?vue&type=script&lang=ts&"
import style0 from "./help-navigation.component.scss?vue&type=style&index=0&id=239fd694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239fd694",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
